
import {chatAppService} from 'langyan';
import {subscribeChatEvents} from './event-handlers';

const attachmentStatusDesc = {
  None: '讀取中',
  PrepareReceive: '準備接收',
  Receiving: '接收中',
  Received: '已接收',
  RecevingFailed: '接收失敗',
  NotExist: '資料不存在',

  PrepareSend: '準備傳送',
  Sending: '傳送中',
  SendingFailed: '傳送失敗',
  Sent: '傳送完成'
};

export default {
  async initChatService({commit, state, rootState, dispatch}, payload) {
    subscribeChatEvents(commit, state, rootState, dispatch);

    let chats = {};

    // retrive chat & messages from local indexedDB
    let currentChats = await chatAppService.getCurrentAllChatsAsync(1);
    currentChats.forEach(chatDto => {
      chats[chatDto.id] = chatDto;
      let participantUsernames = Array.from(chatDto.participants.values());
      // fetch user profile who is the participant of chat.
      dispatch('user/fetchUserByUsernameAsync', participantUsernames, {root: true});
    });
    commit('updateChats', chats);
  },

  async switchChat({commit, state, rootState, dispatch}, {chatId, username}) {
    if (!chatId && !username) {
      let err = new Error('fail to switch or create chat.');
      log.error(err.message, err);
      return;
    }

    let chatDto = state.chats[chatId];
    if (chatDto) {
      chatAppService.reportReadMessageCountToLatest(chatId);
    } else {
      chatDto = findChatByUsername(state.chats, username);
    }

    // create new chat
    if (!chatDto) {
      let newChatId = await chatAppService.openChatWithAsync(username);
      chatDto = await chatAppService.chatOfIdAsync(newChatId);
      commit('updateChat', chatDto);
    }

    let signinUsername = rootState.profile.username;
    let participants = Array.from(chatDto.participants.values());
    let chatUserName = participants[0] !== signinUsername ? participants[0] : participants[1];
    let userDto = rootState.user.users[chatUserName];
    // if user not found in local, fetch it.
    if (!userDto) {
      await dispatch('user/fetchUserByUsernameAsync', chatUserName, {root: true});
    }

    commit('updateCurrentChat', {chatDto, username: chatUserName});
    await dispatch('retrievePreviousMessages', {chatId: chatDto.id});
  },

  reportReadMessage({commit, state, rootState, dispatch}, chatId) {
    let currentChatId = state.currentChat.id;
    if (!chatId || !currentChatId) {
      return;
    }
    if (currentChatId === chatId) {
      chatAppService.reportReadMessageCountToLatest(chatId);
    }
  },

  async retrievePreviousMessages({commit, state, rootState, dispatch}, {chatId, refChatMessageDto}) {
    // if chatId not provided, use current chat's id.
    chatId = chatId ? chatId : state.currentChat.id;
    if (!chatId) {
      let err = new Error('fail to retrieve privious message - invalid chatId', chatId);
      log.error(err.message, err);
      return;
    }
    let messages = await chatAppService.retrieveChatMessagesOfChatBeforeAsync(chatId, state.pageSize, refChatMessageDto);
    commit('updateChatMessages', {chatId, messages});
  },

  async sendTextMessage({commit, state, rootState, dispatch}, text) {
    if (!state.currentChat) {
      log.error('send text message failed. currentChat is nulll.');
      return;
    }

    let chatId = state.currentChat.id;
    let speaker = rootState.profile.username;

    let chatMessageDto = await chatAppService.newTextChatMessageAsync(chatId, speaker, text);
    commit('updateChatMessages', {chatId, messages: [chatMessageDto]});

    await chatAppService.speakToChatAsync(chatMessageDto);
  },

  async sendImageMessage({commit, state, rootState, dispatch}, files) {
    if (!state.currentChat) {
      log.error('send image message failed. currentChat is nulll.');
      return;
    }

    let chatId = state.currentChat.id;
    let speaker = rootState.profile.username;

    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let fragments = file.name.split('.');
      let fileExt = fragments.length < 2 ? null : '.' + fragments[fragments.length-1];
      let chatMessageDto = await chatAppService.newImageChatMessageAsync(chatId, speaker, fileExt, file.type, file._thumbnailBlob, file);
      commit('updateChatMessages', {chatId, messages: [chatMessageDto]});
      await chatAppService.speakToChatAsync(chatMessageDto);
    }
  },

  async sendAudioMessage({commit, state, rootState, dispatch}, blob) {
    if (!state.currentChat) {
      log.error('send audio message failed. currentChat is nulll.');
      return;
    }

    let chatId = state.currentChat.id;
    let speaker = rootState.profile.username;

    let chatMessageDto = await chatAppService.newAudioChatMessageAsync(chatId, speaker, '.webm', blob.type, blob);
    commit('updateChatMessages', {chatId, messages: [chatMessageDto]});
    await chatAppService.speakToChatAsync(chatMessageDto);
  },

  async retriveAttachmentStatus({commit, state, rootState, dispatch}, {chatMessageDto, callback}) {
    let interval;

    const handler = async () => {
      let status;
      let statusDesc;
      try {
        // return ChatMessageAttachmentStatus
        status = await chatAppService.retrieveChatMessageAttachmentStatusAsync(chatMessageDto);
        statusDesc = attachmentStatusDesc[status.Status];
      } catch (e) {
        clearInterval(interval);
        status = e;
      } finally {
        callback({status, statusDesc, chatMessageDto, interval});
      }
    };

    interval = setInterval(handler, 1000);
    await handler();
  },

  async retriveThumbnailStatus({commit, state, rootState, dispatch}, {chatMessageDto, callback}) {
    let interval;

    const handler = async () => {
      let status;
      let statusDesc;

      try {
        // return ChatMessageAttachmentStatus
        status = await chatAppService.retrieveChatMessageThumbnailStatusAsync(chatMessageDto);
        statusDesc = attachmentStatusDesc[status.Status];
      } catch (e) {
        clearInterval(interval);
        status = e;
      } finally {
        callback({status, statusDesc, chatMessageDto, interval, isThumbnail: true});
      }
    };

    interval = setInterval(handler, 1000);
    await handler();
  }
};

function findChatByUsername(chats, username) {
  for (let key in chats) {
    if (!chats.hasOwnProperty(key)) {
      continue;
    }
    let chat = chats[key];
    if (chat.participants.has(username)) {
      return chat;
    }
  }

  return null;
}